import React from 'react';
import { string } from 'prop-types';
import { FormattedMessage } from '../../../util/reactIntl';
import classNames from 'classnames';

import { contacts } from '../data';

import css from './SectionGetInTouch.module.css';


const SectionGetInTouch = props => {

  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  const openWidget = () => {
    if (typeof window !== 'undefined') {
      window.zE('messenger', 'open');
    }
  };

  const items = contacts.map((item) => {
    return <li key={item.data} className={css.contactItem}>
      <a
        onClick={item.chat ? openWidget : null}
        className={css.contactLink}
        href={item.href}
      >
        <span className={css.contactIcon}><img src={item.icon} alt={'icon'} /></span>
        <span className={css.contactData}>{item.data}</span>
      </a>
    </li>;
  });


  return (
    <div className={classes}>
      <div className={css.content}>
        <h2 className={css.mainTitle}>
          <FormattedMessage id='SectionGetInTouch.title' />
        </h2>
        <h3 className={css.subTitle}>
          <FormattedMessage id='SectionGetInTouch.subTitle' />
        </h3>

        <ul className={css.contactList}>{items}</ul>
      </div>
    </div>
  );
};

SectionGetInTouch.defaultProps = { rootClassName: null, className: null };

SectionGetInTouch.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionGetInTouch;
